module.exports = __webpack_public_path__ + "static/scale-model-of-sisters-grimm-ghost-tours-in-san-antonio-texas-71aadf58e62eba0f0e18dc90eb80162d.png";